
export const currencyReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CURRENCIES':
      return {
        ...state,
        currenciesData: action.payload
      };
    case 'SET_CURRENT_CURRENCY':
      return {
        ...state,
        currentCurrency: action.payload,
      };
    default:
      return state;
  }

};
